import { useI18n } from '../i18n';

const UnreadMessageBadge = ({ count }: { count: number }) => {
  const { t } = useI18n();
  if (count <= 0) return null;

  return (
    <span
      className="absolute -right-2 -top-2 inline-flex min-h-[20px] min-w-[20px] items-center justify-center rounded-full bg-rose-600 px-1 text-[10px] font-bold leading-none text-white ring-2 ring-white"
      aria-label={t('messages.unread', { count })}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};

export default UnreadMessageBadge;
